import { navigate } from "@reach/router";
import { Options } from "components/haven-design/snackbar/use-snackbar";
import { loginWithToken } from "utils/general-utils";
import { asteroid } from "data/meteor-server";
import { getReturnToUrl } from "utils/login";

export const chooseNewPassword = (token: string, newPassword: string): Promise<string> =>
  new Promise((resolve, reject) => {
    asteroid
      .call("User.resetPassword", token, newPassword)
      .then((res: { token: string, returnUrl?: string }) => {
        loginWithToken(res.token);

        asteroid
          .call("syncUser", res.token)
          .then(() => resolve(res.returnUrl || ""))
          .catch(() => reject(new Error("Error syncing user")));
      })
      .catch((err: any) => {
        reject(err.reason);
      });
  });

export const setNewUserPassword = (token: string, newPassword: string): Promise<string> =>
  new Promise((resolve, reject) => {
    asteroid
      .call("User.resetPassword", token, newPassword)
      .then((res: { token: string, returnUrl?: string }) => {
        loginWithToken(res.token);

        asteroid
          .call("syncUser", res.token)
          .then(() => resolve(res.returnUrl || ""))
          .catch(() => reject(new Error("Error syncing user")));
      })
      .catch((err: any) => {
        reject(err.reason);
      });
  });

export const requestResetPasswordEmail = ({ email }: { email: string }): Promise<void> =>
  new Promise((resolve) => {
    asteroid
      .call("User.sendResetPasswordEmail", email, getReturnToUrl())
      .then(() => {
        navigate(`/check-email?email=${email}`);
        resolve();
      })
      .catch(() => {
        navigate(`/no-account?email=${email}`);
        resolve();
      });
  });

export const resetPasswordEmail =
  (email: string, openSnackbar: (options: Options) => void): void => {
    asteroid
      .call("User.sendResetPasswordEmail", email)
      .then(() => {
        openSnackbar({ message: "Reset Password Email Sent", status: "success" });
      })
      .catch(() => {
        openSnackbar({ message: "Reset Password Email Failed to Send", status: "error" });
      });
  };

export const sendEnrollmentEmail =
(userId: string, openSnackbar: (options: Options) => void): Promise<string | void> =>
  new Promise((resolve, reject) => {
    asteroid
      .call("User.sendEnrollmentEmail", userId)
      .then(() => {
        openSnackbar({ message: "Success", status: "success" });
        navigate("/dash/manager/settings/team");
        resolve();
      })
      .catch(() => {
        openSnackbar({ message: "Error creating account", status: "error" });
        reject(new Error("Error creating account"));
      });
  });
